import auth from "../middleware/auth";
import duplicidadeAtendimento from "../middleware/duplicidadeAtendimento";

const Solicitar = () => import("../components/Views/Atendimento/Solicitar.vue");
const MeusAtendimentos = () =>
  import("../components/Views/Atendimento/List.vue");
const ListAtendimentos = () =>
  import("../components/Views/Atendimento/Responsavel/List.vue");
const NewAtendimento = () => import("../components/Views/Atendimento/New.vue");
const RespostaAtendimento = () =>
  import("../components/Views/Atendimento/Resposta.vue");
const ViewAtendimento = () =>
  import("../components/Views/Atendimento/View.vue");
const AvaliarAtendimento = () =>
  import("../components/Views/Atendimento/Avaliar.vue");
const EmailInstitucional = () =>
  import("../components/Views/Atendimento/EmailInstitucional.vue");
const Home = () => import("../components/Views/Home.vue");

const breadcrumb = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Atendimento", link: "/atendimento" }
];

const atendimento = [
  {
    path: "/atendimento",
    redirect: "/atendimento/solicitar"
  },
  {
    path: "/atendimento",
    component: Home,
    children: [
      {
        path: "/atendimento/email-institucional",
        component: EmailInstitucional,
        name: "E-mail Institucional",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/atendimento/meus-atendimentos",
        component: MeusAtendimentos,
        name: "Meus Atendimentos",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/atendimento/seus-atendimentos",
        component: ListAtendimentos,
        name: "Seus Atendimentos",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/atendimento/responder/:atendimento",
        component: RespostaAtendimento,
        name: "Nova Interação",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/atendimento/solicitar/:usuario/:isFinalizar",
        component: Solicitar,
        name: "Novo Resposta",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/atendimento/solicitar/:servico/:usuario?/:isFinalizar?/:atendimentoReceptivo?/:privado?",
        component: NewAtendimento,
        name: "Novo Atendimento",
        meta: {
          middleware: [auth, duplicidadeAtendimento],
          breadcrumb
        }
      },
      {
        path: "/atendimento/solicitar",
        component: Solicitar,
        name: "Solicitar Atendimento",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/atendimento/avaliar/:atendimento",
        component: AvaliarAtendimento,
        name: "Avaliar Atendimento",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/atendimento/:atendimento",
        component: ViewAtendimento,
        name: "Visualizar Atendimentos",
        meta: {
          middleware: auth,
          breadcrumb
        }
      }
    ]
  }
];

export default atendimento;



// WEBPACK FOOTER //
// ./src/routes/atendimento.js